<template>
  <div>
    <div class="pt-3 pb-2 mb-3">
      <div class="row">
        <h1 class="h2 text-muted col-md-12">
          MAPPING ENGINE / OUTBOUND FIELD MANAGER
        </h1>
      </div>
      <div
        class="mt-2"
        style="display: flex;
  justify-content: space-between;"
      >
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-toggle="modal"
          data-bs-target="#removeModal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
            />
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            />
          </svg>

          Remove Selected Fields
        </button>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-toggle="modal"
            data-bs-target="#importModal"
          >
            Import
          </button>
          <div class="divider" />
          <button type="button" class="btn btn-secondary" @click="exportCSV">
            Export
          </button>
          <div class="divider" />
          <button
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addModal"
          >
            Add Outbound Field
          </button>
        </div>
      </div>
    </div>
    <hr />
    <form class="row g-3 mt-3 px-3">
      <div class="col-md-1" style="width: 4.16666667%">
        <input
          class="form-check-input"
          type="checkbox"
          @change="selectAll"
          v-model="allSelected"
        />
      </div>
      <div class="col-md-2">
        <h6>Cover ID</h6>
      </div>
      <div class="col-md-2">
        <h6>Product Name</h6>
      </div>
      <div class="col-md-3">
        <h6>Cover Name</h6>
      </div>
      <div class="col-md-4">
        <h6>Cover Definition</h6>
      </div>
    </form>
    <div v-if="loading" class="spinner-border text-primary" />
    <div v-else class="accordion accordion-flush" id="accordionFlushExample">
      <div
        class="accordion-item"
        v-for="(mapping, index) in mappings"
        :key="index"
      >
        <!-- <h2 class="accordion-header"> -->
        <div class="d-flex" style="padding-left: 1rem">
          <div class="col-md-1 align-self-center" style="width: 4.16666667%">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="selected"
              v-bind:value="mapping.coverId"
              :key="mapping.coverId"
              @click="select"
            />
          </div>
          <button
            class="accordion-button collapsed col-md-11"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + mapping.coverId"
            aria-expanded="false"
            aria-controls="flush-collapseOne"
            style="padding: 1rem 0rem; width: 86%"
          >
            <div
              class="col-md-2"
              style="width: 19.4%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              {{ mapping.coverId }}
            </div>
            <div
              class="col-md-2"
              style="width: 19.3%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              {{ mapping.productName }}
            </div>
            <div
              class="col-md-3"
              style="width: 29%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              {{ mapping.coverName }}
            </div>
            <div
              class="col-md-5"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
            >
              {{ mapping.coverDefinition }}
            </div>
          </button>
        </div>
        <!-- </h2> -->
        <div
          :id="'collapse' + mapping.coverId"
          class="accordion-collapse collapse mt-3 px-3"
          aria-labelledby="flush-headingOne"
          data-bs-parent="#accordionFlushExample"
          style="margin-left: 4.16666667%;"
        >
          <form>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Product Name</label>
                <input
                  type="text"
                  class="form-control"
                  :id="'updatedProductName' + mapping.coverId"
                  :value="mapping.productName"
                />
              </div>
              <div class="col-md-6">
                <label class="form-label">Cover Name</label>
                <input
                  type="text"
                  class="form-control"
                  :id="'updatedCoverName' + mapping.coverId"
                  :value="mapping.coverName"
                />
              </div>
            </div>
            <div class="row g-3 mt-1">
              <div class="col-md-12">
                <label class="form-label">Cover Definition</label>
                <textarea
                  rows="4"
                  class="form-control"
                  :id="'updatedCoverDefinition' + mapping.coverId"
                  :value="mapping.coverDefinition"
                />
              </div>
            </div>
          </form>
          <div class="form-group mt-3 mb-3" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelUpdate(mapping.coverId)"
            >
              Cancel
            </button>
            <div class="divider" />
            <button
              class="btn btn-primary"
              type="button"
              @click="updateField(mapping)"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Modal -->
    <div
      class="modal fade"
      id="addModal"
      tabindex="-1"
      aria-labelledby="addModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Add Outbound Field
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="cancelAddField"
            ></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row mb-3">
                <label class="col-sm-3 col-form-label">Product Name</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="newProductName"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <label class="col-sm-3 col-form-label">Cover Name</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="newCoverName"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <label class="col-sm-3 col-form-label">Cover Definition</label>
                <div class="col-sm-9">
                  <textarea
                    rows="4"
                    class="form-control"
                    v-model="newCoverDef"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="cancelAddField"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="addField"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Remove Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Selected Fields
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove selected rows? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="deleteFields"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Import Modal -->
    <div
      class="modal fade"
      id="importModal"
      tabindex="-1"
      aria-labelledby="importModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Upload Outbound Mapping CSV/JSON
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearFile"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3 mt-3">
              <label for="inputGroupFile02" class="col-sm-3 col-form-label"
                >Select a file</label
              >
              <div class="col-sm-9">
                <input
                  ref="file"
                  type="file"
                  class="form-control"
                  id="inputGroupFile02"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="clearFile"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#uploadDetailsModal"
              @click="importCSV"
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Upload Details Modal -->
    <div
      class="modal fade"
      id="uploadDetailsModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="uploadDetailsModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Upload Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearError"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-4 mt-3">
              <div class="row" v-if="fileupload">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">Your Upload has been completed.</div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  Your file could not be uploaded. Please check.
                </div>
              </div>
              <div class="row" v-if="format">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  The format of your file appears to be right.
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  The format of your file does not appear to be right. Please
                  check.
                </div>
              </div>
              <div class="row" v-if="entries">
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="green"
                    class="bi bi-check-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  {{ numentries }} Entries have been processed.
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-sm-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="red"
                    class="bi bi-x-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </div>
                <div class="col-sm-11">
                  No entries have been processed. Please check.
                </div>
              </div>
            </div>
            <div
              class="alert alert-danger align-items-center"
              role="alert"
              v-if="errorDuplicate || errorType"
            >
              <div class="d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                  viewBox="0 0 16 16"
                  role="img"
                  aria-label="Warning:"
                >
                  <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                  />
                </svg>
                <div>
                  Warning: The following rows have not been processed.
                </div>
              </div>
              <div v-if="errorDuplicate">
                Mappings in rows:
                {{ duplicate_source_field_list }} are already present.
              </div>
              <div v-if="errorType">
                Rows: {{ wrong_type_list }} have invalid source field types.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import $ from "jquery";
export default {
  data() {
    return {
      mappings: [],
      selected: [],
      allSelected: false,
      newProductName: "",
      newCoverName: "",
      newCoverDef: "",
      confirmDelete: "",
      fileupload: false,
      format: false,
      entries: false,
      numentries: 0,
      errorDuplicate: false,
      errorType: false,
      duplicate_source_field_list: [],
      wrong_type_list: [],
      loading: true,
    };
  },
  methods: {
    async exportCSV() {
      let csv = '"coverId","productName","coverName","coverDefinition"\n';
      this.mappings.forEach((mapping) => {
        csv +=
          '"' +
          mapping.coverId +
          '","' +
          mapping.productName +
          '","' +
          mapping.coverName +
          '","' +
          mapping.coverDefinition;
        csv += '"\n';
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Outbound_Mappings.csv";
      anchor.click();
    },
    async importCSV() {
      const filedata = new FormData();
      filedata.append("mapping_file", this.$refs.file.files.item(0));
      $("#inputGroupFile02").val("");
      const requestOptions = {
        method: "POST",
        credentials: "include",
        body: filedata,
      };
      const response = await fetch(
        config.baseURL + "/save_mapping_field_file",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      this.getDeets();
      if (data) this.fileupload = true;
      if (data["Format"]) this.format = true;
      if (data["Number_of_rows_added"]) {
        this.entries = true;
        this.numentries = data["Number_of_rows_added"];
      }
      if (data.duplicate_source_field_list.length !== 0) {
        this.errorDuplicate = true;
        this.duplicate_source_field_list = data.duplicate_source_field_list;
      }
      if (data.wrong_type_list.length !== 0) {
        this.errorType = true;
        this.wrong_type_list = data.wrong_type_list;
      }
    },
    clearFile() {
      $("#inputGroupFile02").val("");
    },
    clearError() {
      this.fileupload = false;
      this.format = false;
      this.entries = false;
      this.numentries = 0;
      this.errorDuplicate = false;
      this.duplicate_source_field_list = [];
      this.errorType = false;
      this.wrong_type_list = [];
    },
    async addField() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            productName: this.newProductName,
            coverName: this.newCoverName,
            coverDefinition: this.newCoverDef,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/add_mapping_field",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) {
        this.getDeets();
        this.cancelAddField();
      }
    },
    cancelAddField() {
      this.newProductName = "";
      this.newCoverName = "";
      this.newCoverDef = "";
    },
    async updateField(mapping) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            coverId: mapping.coverId,
            productName: $("#updatedProductName" + mapping.coverId).val(),
            coverName: $("#updatedCoverName" + mapping.coverId).val(),
            coverDefinition: $(
              "#updatedCoverDefinition" + mapping.coverId
            ).val(),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_mapping_field",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) {
        this.getDeets();
        $("#collapse" + mapping.coverId).collapse("hide");
      }
    },
    cancelUpdate(id) {
      $("#collapse" + id).collapse("hide");
      this.getDeets();
    },
    async deleteFields() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              coverId: this.selected,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_mapping_field",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Removed"]) {
          location.reload();
        } else {
          console.log("nope");
          this.confirmDelete = "";
        }
      } else {
        this.confirmDelete = "";
      }
    },
    selectAll() {
      this.selected = [];
      if (this.allSelected) {
        for (var mapping in this.mappings) {
          this.selected.push(this.mappings[mapping].coverId);
        }
      }
    },
    select() {
      this.allSelected = false;
    },
    async getDeets() {
      const res = await fetch(config.baseURL + "/get_mapping_fields", {
        credentials: "include",
      });
      const data = await res.json();
      console.log(data);
      this.mappings = data;
      this.loading = false;
    },
  },
  mounted() {
    this.getDeets();
  },
};
</script>

<style scoped>
.divider {
  width: 10px;
  height: auto;
  display: inline-block;
}
.spinner-border {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15%;
}
</style>
